import { createFeatureSelector } from 'features/create-feature-selector';
import { createSelector } from 'reselect';

const postReviewFeatureSelector = createFeatureSelector('reviews');
export const getPostReviewErrors = createSelector(postReviewFeatureSelector, (f) => f.postReview.error);
export const getPostReviewIsPerforming = createSelector(
  postReviewFeatureSelector,
  (f) => f.postReview.isPerforming,
);
export const getPostReviewResultStatus = createSelector(
  postReviewFeatureSelector,
  (f) => f.postReview.resultStatus,
);
